import React, { useState } from "react";
import { Grid,Box, Typography, TextField, Button } from "@mui/material";
import { BaseUrl, Change_Password } from "../../services/Url";
import { toast } from 'react-toastify';

const ChangePassword = () => {
  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const token = localStorage.getItem("token");
  
  function restAPI(){
    const CompleteUrl = BaseUrl  + Change_Password;
    const res = fetch(CompleteUrl, {
        method: "POST",
        headers: { 
          'Content-Type': 'application/json',
          'x-access-token': token,
        },
        body: JSON.stringify({
            "old_password" :oldPassword ,
            "password" : newPassword,
        })
    });

    res.then(async (res)=>{
      const response = await res.json();
      if(response.response === "success"){
        toast.success("Password Changed");
      }
      else{
        toast.error(response.message);
      }
    })
  }

  const changePasswordHandler = (e)=>{
    if(!oldPassword || !newPassword || !confirmPassword){
      toast.error("Please fill All Fields")
    }
    else if(newPassword === confirmPassword){
      restAPI();
      setOldPassword("");
      setNewPassword("");
      setConfirmPassword("");
    }else{
      toast.error("Password did not matched");
    }
  }


  return (
    <Box className="changePass_cont">
      <Box className="box-wrapper br-24 " sx={{p:5}}>
      <div className='heading-btn_wrapper'>
				<h5 className='fz-20 fw-bold'>Change Password</h5>
			</div>
        <Box className="form_wrapper pwd_form">
          <Grid container spacing={2}>
            <Grid item xs={7}>
              <Box className="inpt_bx">
                <Typography variant="h6">Current Password</Typography>
                <TextField
                  placeholder="**************"
                  fullWidth
                  name="currentpassword"
                  type={"password"}
                  value={oldPassword}
                  variant="standard"
                  onChange={(e)=>setOldPassword(e.target.value)}
                />
              </Box>
            </Grid>
            <Grid item xs={7}>
              <Box className="inpt_bx">
                <Typography variant="h6">New Password</Typography>
                <TextField
                  placeholder="**************"
                  fullWidth
                  name="Newpassword"
                  type={"password"}
                  value={newPassword}
                  variant="standard"
                  onChange={(e)=>setNewPassword(e.target.value)}
                />
              </Box>
            </Grid>
            <Grid item xs={7}>
              <Box className="inpt_bx">
                <Typography variant="h6">Confirm Password</Typography>
                <TextField
                  placeholder="**************"
                  fullWidth
                  name="confirmpassword"
                  type={"password"}
                  value={confirmPassword}
                  variant="standard"
                  onChange={ (e)=>setConfirmPassword(e.target.value)}
                />
              </Box>
            </Grid>
          </Grid>
          <Box>
          <Button className="btn btn-design" sx={{mt:4, mb:3}} onClick={changePasswordHandler}>Submit</Button>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default ChangePassword;